import { PesquisaAtendimentoForm } from 'src/app/models/pesquisa-atendimento.mode';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IdentificacaoAtendimento } from '../models/Servico.model';

@Injectable({
  providedIn: 'root',
})
export class PesquisaServicoService {
  constructor(private http: HttpClient) {}

  getIdentificadorPesquisa(
    id: number,
    hash: string
  ): Observable<IdentificacaoAtendimento> {
    return this.http.get<IdentificacaoAtendimento>(
      `/api/pesquisaatendimento/consultar/${id}/${hash}`
    );
  }

  postPesquisa(form: PesquisaAtendimentoForm) {
    return this.http.post(`/api/pesquisaatendimento/gravar`, form);
  }
}
